export type PackConfigValue = {
    field: string
    id: string
}
export type LocalePackConfig = {
    label: string
    values: PackConfigValue[]
}[]
export type PackConfig = {
    [locale: string]: LocalePackConfig
}

const packConfig: PackConfig = {
    fr_FR: [
        {
            label: 'Hébergement',
            values: [
                {
                    field: 'packages',
                    id: 'HS'
                }
            ]
        },
        {
            label: 'Hébergement + Skipass',
            values: [
                {
                    field: 'packages',
                    id: 'PF'
                }
            ]
        },
        {
            label: 'Train + Hébergement + Skipass',
            values: [
                {
                    field: 'packages',
                    id: 'PFTTF'
                }
            ]
        },
        {
            label: 'Train + Hébergement + Skipass + Matériel de ski',
            values: [
                {
                    field: 'packages',
                    id: 'PFPTTF'
                }
            ]
        },
        {
            label: 'Hébergement + Skipass - Court-séjour',
            values: [
                {
                    field: 'packages',
                    id: 'PFCS'
                }
            ]
        },
        {
            label: 'Hébergement + Skipass + Matériel',
            values: [
                {
                    field: 'packages',
                    id: 'PFP'
                }
            ]
        },
        {
            label: 'Hébergement + Skipass + Matériel - Court-séjour',
            values: [
                {
                    field: 'packages',
                    id: 'PFPCS'
                }
            ]
        },
        {
            label: 'Hébergement + Pass Multi Activité',
            values: [
                {
                    field: 'packages',
                    id: 'PMA'
                }
            ]
        },
        {
            label: 'Hébergement + Skipass',
            values: [
                {
                    field: 'packages',
                    id: 'OPPF'
                }
            ]
        },
        {
            label: 'Hébergement + Skipass + Matériel',
            values: [
                {
                    field: 'packages',
                    id: 'OPPFCS'
                }
            ]
        },
        {
            label: 'Hébergement + Skipass + Matériel',
            values: [
                {
                    field: 'packages',
                    id: 'OPPFP'
                }
            ]
        },
        {
            label: 'Hébergement + Skipass + Matériel',
            values: [
                {
                    field: 'packages',
                    id: 'OPPFPCS'
                }
            ]
        },
        {
            label: 'Hébergement + Skipass + Matériel',
            values: [
                {
                    field: 'packages',
                    id: 'OPPFP6'
                }
            ]
        },
        {
            label: 'Hébergement + Skipass + Matériel',
            values: [
                {
                    field: 'packages',
                    id: 'OPPFP7'
                }
            ]
        },
        {
            label: 'Hébergement + Skipass + Matériel',
            values: [
                {
                    field: 'packages',
                    id: 'OPPFP8'
                }
            ]
        },
        {
            label: 'Hébergement + Skipass + Matériel + Panier de courses',
            values: [
                {
                    field: 'packages',
                    id: 'OPPTC'
                }
            ]
        },
        {
            label: 'Hébergement + Skipass + Matériel + Panier de courses',
            values: [
                {
                    field: 'packages',
                    id: 'OPPTC6'
                }
            ]
        },
        {
            label: 'Hébergement + Skipass + Matériel + Panier de courses',
            values: [
                {
                    field: 'packages',
                    id: 'OPPTC8'
                }
            ]
        },
        {
            label: 'Hôtel + Demi-pension',
            values: [
                {
                    field: 'packages',
                    id: 'CVDP'
                }
            ]
        },
        {
            label: 'Hôtel + Demi-pension',
            values: [
                {
                    field: 'packages',
                    id: 'CVPC'
                }
            ]
        },
        {
            label: 'Hôtel + Petit-déjeuner',
            values: [
                {
                    field: 'packages',
                    id: 'CVPD'
                }
            ]
        },
        {
            label: 'Hotel + All inclusive',
            values: [
                {
                    field: 'packages',
                    id: 'CVAL'
                }
            ]
        },
        {
            label: 'PFCS3N3JS',
            values: [
                {
                    field: 'packages',
                    id: 'PFCS3N3JS'
                }
            ]
        }
    ],
    en_US: [
        {
            label: 'Skitrain + Accommodation + Ski pass',
            values: [
                {
                    field: 'packages',
                    id: 'PFTT'
                }
            ]
        },
        {
            label: 'Accommodation',
            values: [
                {
                    field: 'packages',
                    id: 'HS'
                }
            ]
        },
        {
            label: 'Accommodation + Ski pass',
            values: [
                {
                    field: 'packages',
                    id: 'PF'
                }
            ]
        },
        {
            label: 'Accommodation + Ski pass - Short stay',
            values: [
                {
                    field: 'packages',
                    id: 'PFCS'
                }
            ]
        },
        {
            label: 'Accommodation + Ski pass + Equipment',
            values: [
                {
                    field: 'packages',
                    id: 'PFP'
                }
            ]
        },
        {
            label: 'Accommodation + Ski pass + Equipment - Short stay ',
            values: [
                {
                    field: 'packages',
                    id: 'PFPCS'
                }
            ]
        },
        {
            label: 'Accommodation + Pass Multi Activities',
            values: [
                {
                    field: 'packages',
                    id: 'PMA'
                }
            ]
        },
        {
            label: 'Hotel + Half Board',
            values: [
                {
                    field: 'packages',
                    id: 'CVDP'
                }
            ]
        },
        {
            label: 'Hotel + Full Board',
            values: [
                {
                    field: 'packages',
                    id: 'CVPC'
                }
            ]
        },
        {
            label: 'Hotel + Breakfast',
            values: [
                {
                    field: 'packages',
                    id: 'CVPD'
                }
            ]
        },
        {
            label: 'Hotel + All inclusive',
            values: [
                {
                    field: 'packages',
                    id: 'CVAL'
                }
            ]
        }
    ],
    nl_NL: [
        {
            label: 'Accommodatie + Skipas + Gratis Skimateriaal',
            values: [
                {
                    field: 'packages',
                    id: 'PFP'
                }
            ]
        },
        {
            label: 'Accommodatie + Skipas + Gratis Skimateriaal - Kort verblijf',
            values: [
                {
                    field: 'packages',
                    id: 'PFPCS'
                }
            ]
        },
        {
            label: 'Accommodatie',
            values: [
                {
                    field: 'packages',
                    id: 'HS'
                }
            ]
        },
        {
            label: 'Accommodatie + Skipas',
            values: [
                {
                    field: 'packages',
                    id: 'PF'
                }
            ]
        },
        {
            label: 'Trein + Accommodatie + Skipas',
            values: [
                {
                    field: 'packages',
                    id: 'PFTT'
                }
            ]
        },
        {
            label: 'Accommodatie + Skipas - Kort verblijf',
            values: [
                {
                    field: 'packages',
                    id: 'PFCS'
                }
            ]
        },

        {
            label: 'Accommodatie + Activiteitenpas',
            values: [
                {
                    field: 'packages',
                    id: 'PMA'
                }
            ]
        },
        {
            label: 'Accommodatie + Skipas',
            values: [
                {
                    field: 'packages',
                    id: 'PFDW'
                }
            ]
        },
        {
            label: 'Hotel + Halfpension',
            values: [
                {
                    field: 'packages',
                    id: 'CVDP'
                }
            ]
        },
        {
            label: 'Hotel + Volpension',
            values: [
                {
                    field: 'packages',
                    id: 'CVPC'
                }
            ]
        },
        {
            label: 'Hotel + Ontbijt',
            values: [
                {
                    field: 'packages',
                    id: 'CVPD'
                }
            ]
        },
        {
            label: 'Hotel + All inclusive',
            values: [
                {
                    field: 'packages',
                    id: 'CVAL'
                }
            ]
        }
    ]
}

export default packConfig
